import axiosWithAuth from '@/utils/axiosWithAuth';
import formatLocationLabel from '@/utils/formatLocationLabel';

// PPSuite proxies Mapbox geocoding; axiosWithAuth camel-cases Mapbox's response keys.
const LOCATIONS_API = '/mapbox_geocode';

type Geometry = {
  coordinates: number[];
};

type Context = {
  id: string;
  textEn: string;
};

type Feature = {
  id: string;
  placeType: string[];
  textEn: string;
  placeNameEn?: string;
  placeName?: string;
  center?: number[];
  geometry: Geometry;
  context?: Context[];
};

type ResponsePayload = {
  type: string;
  features: Feature[];
};

export type FetchedLocationValue = {
  longitude: number;
  latitude: number;
  place?: string;
  region?: string;
  country?: string;
};

export type FetchedLocation = {
  id: string;
  value: FetchedLocationValue;
  localeLabelKey: string;
};

function mapFeatureToLocationValue(feature: Feature): FetchedLocationValue {
  const {context} = feature;
  const {placeType} = feature;
  const [longitude, latitude] = feature.center || feature.geometry.coordinates;
  let place;
  let region;
  let country;

  if (context) {
    context.forEach((contextItem) => {
      if (contextItem.id.includes('region')) {
        region = contextItem.textEn;
      } else if (contextItem.id.includes('country')) {
        country = contextItem.textEn;
      }
    });
  }
  if (placeType.includes('place')) {
    place = feature.textEn;
  }
  if (placeType.includes('country')) {
    country = feature.textEn;
  }
  if (placeType.includes('region')) {
    region = feature.textEn;
  }
  return {
    longitude,
    latitude,
    place,
    region,
    country,
  };
}

const locationFetchers = {
  locations: async (
    query: string,
    restrictCountry = false,
    restrictRegion = false
  ) => {
    let types = ['place', 'region', 'country'];

    if (restrictRegion) {
      types = types.filter((type) => type !== 'region');
    }

    if (restrictCountry) {
      types = types.filter((type) => type !== 'country');
    }

    const response = await axiosWithAuth.get<ResponsePayload>(LOCATIONS_API, {
      params: {query, types: types.join(','), limit: 10},
    });

    return response.data.features.map((feature: Feature) => {
      const value = mapFeatureToLocationValue(feature);
      return {
        id: feature.id,
        value,
        localeLabelKey:
          feature.placeNameEn ||
          feature.placeName ||
          formatLocationLabel(value),
      };
    });
  },
};

export default locationFetchers;
